<template>
    <div class="display-code">
        <text-area :name="name" class="textarea" title="" ref="area" :disabled="true" :placeholder="placeholder" v-model="newValue"/>
        <button v-on:click="copyToClipboard">copy</button>
    </div>
</template>

<script>
import { Default } from '@/mixins/mixins';
import textArea from './textarea';

export default {
    name: 'displayTextarea',
    mixins: [
        Default
    ],
    components: {
        textArea
    },
    props: ['name', 'placeholder', 'value'],
    data() {
        return {
            newValue: ''
        };
    },
    created() {
        this.newValue = this.value;
    },
    methods: {
        copyToClipboard: function() {
            document.oncopy = function(event) {
                event.clipboardData.setData('Text', this.newValue);
                event.preventDefault();
            }.bind(this);
            document.execCommand('Copy');
            document.oncopy = undefined;
            this.$parleyAdmin.queryErrors.addError('Text copied to clipboard', this.$parleyAdmin.queryErrors.TYPE_SUCCESS);
        }
    },
    watch: {
        value: function(newVal, oldVal) {
            if (newVal !== oldVal)
                this.newValue = newVal;
        },
        newValue: function(newVal, oldVal) {
            this.$emit('input', newVal);
        }
    }
};
</script>

<style lang="scss" scoped>
    @import "../../../assets/styles/customInput/input";

    .display-code {
        @extend %input-with-button;
        button {
            right: 0;
            top: 0;
            width: 4em;
            margin: .25em .25em 0 0;
            padding: .25em;
        }
    }
</style>

<style lang="scss">
    .display-code {
        .textarea {
            textarea {
                resize: none;
                overflow: hidden;
                padding: .25em 4em .25em .25em;
                height: auto;
            }
        }
    }
</style>